import globalStore from "@/store";

const virtualFence = {
  namespaced: true,
  state: {
    polygonPath: [],
  },
  actions: {
    GET_VIRTUAL_FENCE: function({ state }) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .get("/virtualfence")
          .then(function(response) {
            globalStore.commit("virtualFence/SET_PLYGON_PATH", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
    CREATE_VIRTUAL_FENCE: function({ state }) {
      return new Promise((resolve, reject) => {
        globalStore.state.$axios_auth
          .post("/virtualfence", state.polygonPath)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error.response);
          });
      });
    },
  },
  mutations: {
    SET_PLYGON_PATH: function(state, model = null) {
      model == null ? (state.polygonPath = []) : (state.polygonPath = model);
    },
  },
};
export default virtualFence;
